var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.217 52.4128C147.114 57.7972 140.821 63.318 134.581 68.9068C134.214 69.234 134.159 70.1746 134.282 70.7471C135.617 76.5541 134.541 81.734 130.031 85.7961C125.795 89.6129 120.768 90.5399 115.401 88.6451C110.115 86.7912 107.077 82.8654 105.878 77.4674C105.347 75.0546 105.606 72.6827 106.341 70.3245C106.491 69.861 106.219 69.0159 105.851 68.6887C99.9116 63.3861 93.9312 58.1244 87.9235 52.8899C87.5966 52.6037 86.861 52.3856 86.534 52.5491C81.8614 54.9346 77.2706 54.7983 72.6661 52.1675C68.7155 55.6435 64.7785 59.0922 60.8552 62.5546C58.6891 64.463 56.6049 66.4532 54.3571 68.2389C53.2809 69.0977 53.1856 69.8747 53.4853 71.0879C55.5014 79.2122 51.1149 86.9003 43.3091 89.0268C35.5305 91.1533 27.3705 86.4504 25.4497 78.7214C23.4335 70.6516 28.1742 62.7182 36.1026 61.0279C39.304 60.3463 42.4508 60.7825 45.3797 62.282C46.2788 62.7454 46.7965 62.6091 47.5049 61.9548C53.349 56.6113 59.2068 51.2951 65.1055 46.0197C65.882 45.3381 66.0046 44.752 65.7321 43.7978C63.4707 35.4963 67.9526 28.0399 76.208 26.2405C86.5749 23.9913 95.7975 33.3425 93.2637 43.6478C92.8822 45.1882 93.2092 46.0197 94.3535 47.0012C100.075 51.9357 105.728 56.9521 111.368 61.9684C112.077 62.5955 112.622 62.7318 113.521 62.3638C117.648 60.6871 121.79 60.6462 125.945 62.3501C126.408 62.541 127.252 62.4047 127.634 62.0775C133.832 56.6795 139.949 51.186 146.161 45.8016C147.128 44.9701 146.638 44.2476 146.46 43.4843C144.594 35.7007 148.477 28.2443 155.738 25.7634C161.241 23.8823 167.603 25.5453 171.349 29.8392C175.313 34.3785 176.104 40.8807 173.352 46.2514C170.682 51.4586 165.11 54.6075 159.252 53.9941C157.304 53.7896 155.411 53.0126 153.19 52.4128H153.217Z",
    fill: "url(#paint0_linear_71_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2825 75.5181H94.0537V174.932H65.2825V75.5181Z",
    fill: "url(#paint1_linear_71_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.657 75.5181H174.469V174.946H145.657V75.5181Z",
    fill: "url(#paint2_linear_71_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.268 175H105.442V110.66H134.268V175Z",
    fill: "url(#paint3_linear_71_781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0955 174.986V110.66H53.9484V174.986H25.0955Z",
    fill: "url(#paint4_linear_71_781)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_781",
    x1: 99.9816,
    y1: 24.9966,
    x2: 99.9816,
    y2: 89.5968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_781",
    x1: 79.6681,
    y1: 75.5181,
    x2: 79.6681,
    y2: 174.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_781",
    x1: 160.063,
    y1: 75.5181,
    x2: 160.063,
    y2: 174.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_781",
    x1: 119.855,
    y1: 110.66,
    x2: 119.855,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_781",
    x1: 39.5219,
    y1: 110.66,
    x2: 39.5219,
    y2: 174.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsMonitoring);
export default __webpack_public_path__ + "static/media/Analytics_&_Monitoring.dc73753029450f1ac4c223b77405676f.svg";
export { ForwardRef as ReactComponent };